module.exports = __webpack_public_path__ + "static/media/woman_and_stars.d27dd68a.svg";